
export const NEW = 'NEW'
export const PENDING_RECEIPT = 'PENDING_RECEIPT'
export const SCHEDULED = 'SCHEDULED'
export const REVIEW = 'REVIEW'

export const PREPARING = 'PREPARING'
export const READY = 'READY'
export const ON_THE_WAY = 'ON_THE_WAY'
export const DELIVERED = 'DELIVERED'
export const WAITING = 'WAITING'


export const ORDER_STATES = [  SCHEDULED, REVIEW, NEW, PREPARING, READY, ON_THE_WAY, DELIVERED]
export const ORDER_STATES_SALON = [ NEW, PREPARING, READY, DELIVERED]

export const ORDER_STATES_WAITER = [ WAITING, DELIVERED]
